import { z } from 'zod';

export const verifyMfaTokenPostRequestSchema = z.object({ user_code: z.string() });
